import { render, staticRenderFns } from "./ChangeEmailVerificationModal.vue?vue&type=template&id=b3f1f0f4&scoped=true&"
import script from "./ChangeEmailVerificationModal.vue?vue&type=script&lang=js&"
export * from "./ChangeEmailVerificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEmailVerificationModal.vue?vue&type=style&index=0&id=b3f1f0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f1f0f4",
  null
  
)

export default component.exports